import { getCurrentConfig } from '~/Store/Bootstrap';


export const getSystemConfig = () => {
  const config = getCurrentConfig();
  return {
    IDENTITY_SERVER_URL: config.identityServerUrl,
    LICENSE_MANAGER_URL: config.licenseManagerUrl,
    CLIENT_ID: config.clientId,
    REDIRECT_URI: config.redirectUri,
    POST_LOGOUT_REDIRECT_URI: config.postLogoutRedirectUri,
    SCOPE: config.scope,
  };
};

export const SYSTEM_CONSTANT = {
  get IDENTITY_SERVER_URL() {
    return getSystemConfig().IDENTITY_SERVER_URL;
  },
  get LICENSE_MANAGER_URL() {
    return getSystemConfig().LICENSE_MANAGER_URL;
  },

  /** OpenIddict client_id công khai (Public client, không có client_secret) — admin-react. */
  get CLIENT_ID() {
    return getSystemConfig().CLIENT_ID;
  },

  /** Phải khớp CHÍNH XÁC 1 trong các RedirectUris đã đăng ký cho client này ở identity-service. */
  get REDIRECT_URI() {
    return getSystemConfig().REDIRECT_URI;
  },

  /** Phải khớp CHÍNH XÁC 1 trong các PostLogoutRedirectUris đã đăng ký cho client này. */
  get POST_LOGOUT_REDIRECT_URI() {
    return getSystemConfig().POST_LOGOUT_REDIRECT_URI;
  },

  /** Scope yêu cầu ở /connect/authorize — offline_access để nhận refresh_token. */
  get SCOPE() {
    return getSystemConfig().SCOPE;
  },
}
